export class User {
    id: number;
    username: string;
    password: string;
    name: string;
}